import { domain } from "@src/utils/request";

export interface IFarmer {
  username: string;
  name: string;
  farmName: string;
  prefecture: string;
  avatar: string;
  avatarDescription?: string;
  title?: string;
  company?: string;
  quickBio?: string;
  facebook?: string;
  x?: string;
  instagram?: string;
  youtube?: string;
}

export default function setupFarmerProfile() {
  const profileEle = document.querySelector<HTMLElement>(
    ".container-farmer-profile"
  );
  if (!profileEle) return;
  const farmerId = profileEle.dataset.farmerUsername;

  const profileCardEle = profileEle.querySelector(
    ".container-farmer-profile-card__clickable"
  );
  if (!profileCardEle) return;
  profileCardEle.addEventListener("click", (e) => {
    const target = e.target as HTMLElement | null;
    if (target?.closest("a")) return;
    window.open(`${domain}/farmers/${farmerId}`, "_blank");
  });
}

export function reRenderFramerProfile(profile: IFarmer) {
  const profileEle = document.querySelector<HTMLElement>(
    ".container-farmer-profile"
  );
  if (!profileEle) return;

  const ele = profileEle.querySelector<HTMLImageElement>(
    `[data-render-position-id="avatar"]`
  );
  if (ele && ele.src !== profile.avatar) {
    ele.src = profile.avatar;
    ele.alt = profile.avatarDescription || "avatar";
  }

  updateText(profileEle, "name", profile.name);
  updateText(profileEle, "title", profile.title);
  updateText(profileEle, "quickBio", profile.quickBio);
  profileEle
    .querySelectorAll<HTMLAnchorElement>(`[data-sns-type]`)
    .forEach((item) => {
      const type = item.dataset?.snsType;
      if (!type) return;
      const value = profile[type as keyof typeof profile];
      item.href = value || "";
      item.setAttribute("data-hidden", value ? "" : "true");
    });
}

function updateText(
  parentEle: HTMLElement,
  positionId: string,
  newText?: string
) {
  if (!newText) return;
  const ele = parentEle.querySelector<HTMLElement>(
    `[data-render-position-id="${positionId}"]`
  );
  if (ele && ele.textContent !== newText) {
    ele.textContent = newText;
  }
}
